module.exports = __webpack_public_path__ + "img/room-detail.c8d6b50d.png";